import { isImageFitCover, isImageSlide, RenderSlideProps, useLightboxProps } from 'yet-another-react-lightbox'
import { Img } from '@boltenergy-be/design-system'

const NextJsImage = ({ slide, rect }: RenderSlideProps) => {
  const { imageFit } = useLightboxProps().carousel
  const cover = isImageSlide(slide) && isImageFitCover(slide, imageFit)

  const width = !cover ? Math.round(Math.min(rect.width, (rect.height / (slide.height || 100)) * (slide.width || 100))) : rect.width
  const height = !cover ? Math.round(Math.min(rect.height, (rect.width / (slide.width || 100)) * (slide.height || 100))) : rect.height

  return (
    <div style={{ height, position: 'relative', width }}>
      <Img
        fill
        alt=""
        publicId={slide.src}
        style={{
          objectFit: cover ? 'cover' : 'contain'
        }}
        sizes={`${Math.ceil((width / window.innerWidth) * 100)}vw`}
      />
    </div>
  )
}

export default NextJsImage
